
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","stroke":"currentColor","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.07 5.253v3.972l3.122 1.904M2.075 6.12a7.68 7.68 0 118.999 10.037","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M7.239 17.05H1.442a.446.446 0 01-.446-.447v-.362a1.873 1.873 0 011.868-1.867h2.953a1.873 1.873 0 011.868 1.867v.362c0 .246-.2.446-.446.446zM4.34 12.144a1.784 1.784 0 110-3.567 1.784 1.784 0 010 3.567z","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    